<template>
  <header id="dealer-header" class="container">
    <!-- Logo and Project title -->
    <div class="logo-and-title" :style="{ 'justify-content': logoPosition }">
      <router-link
        :to="projectRoute"
        class="d-flex"
        title="go to project route"
      >
        <img
          :style="{ 'max-width': dealer.logo_size + '%' }"
          :src="dealer.logo"
        />
        <h1 class="project-title slate-bold">{{ projectTitle }}</h1>
      </router-link>
    </div>

    <!-- Right section -->
    <div class="search-rep-and-cart-container">
      <div class="rep-info-container" v-if="hideRepInfo">
        <span>Prepared by</span>
        <span class="slate-bold">
          {{ (projectRep && projectRep.name) || "No Name" }}
        </span>

        <!-- Dropdown menu -->
        <div class="dropdown-menu-container">
          <button
            title="Open Dealer Menu"
            @click="toggleShowRepDropdown"
            id="toggle-rep-dropdown-button"
          >
            <img
              class="info-icon"
              src="@/assets/icons/ui/information-circle-outline.svg"
              alt="more info icon"
            />
          </button>

          <div
            class="rep-info-dropdown"
            role="dropdown"
            v-show="showRepDropdown"
          >
            <div class="info-options">
              <div class="rep-info-dropdown-item">
                <img
                  src="@/assets/icons/ui/call-outline.png"
                  alt="phone icon"
                />
                <a :href="`tel:${projectRep && repPhone}`">{{
                  repPhone
                }}</a>
              </div>
              <div class="rep-info-dropdown-item">
                <img
                  src="@/assets/icons/ui/mail-outline.png"
                  alt="email icon"
                />
                <a :href="`mailto:${projectRep && projectRep.email}`">{{
                  projectRep && projectRep.email
                }}</a>
              </div>
              <!-- <div class="contact-rep">
                <p>You need assistance?</p>
                <button class="btn">Send a message</button>
              </div> -->
            </div>
            <!-- Dealer Mode -->
            <div class="dealer-mode-option" v-if="!dealerMode">
              <button class="login-btn" @click="handleOpenLoginModal">
                <img
                  src="@/assets/icons/ui/log-in-outline.svg"
                  alt="log in icon"
                />
                Dealer Mode
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Go to locker -->
      <router-link class="cart" :to="lockerRoute">
        <div
          v-if="quantityOfProductInLocker"
          class="locker-quantity slate-bold"
          title="quantity of locker's products"
        >
          {{ quantityOfProductInLocker }}
        </div>
        <img
          title="Your Locker"
          src="@/assets/icons/ui/cart-outline.png"
          alt="cart icon"
        />
      </router-link>

      <!-- Pagination Toggle -->
      <div class="pagination-toggle" v-if="isPlaybook && !lockerOpened">
        <button
          @click="togglePaginationSidebar"
          id="toggle-pagination-sidebar-button"
          title="Toggle Pagination Sidebar"
        >
          <img
            v-if="!paginationActive"
            class="info-icon"
            src="@/assets/icons/ui/circled-arrow.png"
            alt="toggle sidebar on"
          />

          <img
            v-else
            class="info-icon"
            src="@/assets/icons/ui/close-outline.png"
            alt="toggle sidebar off"
          />
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import router from "@/router";

export default {
  name: "DealerHeader",

  data() {
    return {
      showRepDropdown: false,
    };
  },

  computed: {
    ...mapState("auth", ["dealerMode"]),
    ...mapState(["dealer"]),
    ...mapState(["lockerModule"]),
    ...mapState("project", ["typeOfProject", "paginationActive"]),
    ...mapState("dealer", ["rhino_code", "fsg_code"]),

    ...mapGetters("project", [
      "projectTitle",
      "projectRep",
      "projectId",
      "projectRoute",
      "isPlaybook",
    ]),

    lockerOpened() {
      return router.currentRoute.name === "Playbook Locker";
    },

    logoPosition() {
      if (this.isDealerLoaded) {
        switch (this.dealer.logo_alignment) {
          case "0":
            return "flex-start";
          case "1":
            return "center";
          case "2":
            return "flex-end";
        }
      }
      return "flex-start";
    },

    isDealerLoaded() {
      return this.dealer?.id;
    },

    quantityOfProductInLocker() {
      return this.lockerModule?.locker?.products?.length;
    },

    lockerRoute() {
      const typeOfProject = this.typeOfProject + "s";
      
      if(typeOfProject === "showrooms") {
        return `/${typeOfProject}/${this.fsg_code}/locker`
      }

      return `/${typeOfProject}/${this.rhino_code}/${this.projectId}/locker`;
    },

    hideRepInfo() {
      return this.typeOfProject !== 'showroom';
    },

    repPhone() {
      const phone = this.projectRep?.phone;
      if (!phone) return null;
      return phone?.includes("-")
        ? phone
        : `(${phone.substring(0, 3)}) ${phone.substring(
            3,
            6
          )}-${phone.substring(6)}`;
    },

  },

  methods: {
    ...mapActions("project", ["triggerPaginationSidebar"]),
    toggleShowRepDropdown() {
      this.showRepDropdown = !this.showRepDropdown;
    },

    handleOpenLoginModal() {
      this.$emit("openDealerLoginModal");
      this.toggleShowRepDropdown();
    },

    togglePaginationSidebar() {
      this.triggerPaginationSidebar(!this.paginationActive);
    },
  },
};
</script>

<style lang="scss" scoped>
#dealer-header {
  background-color: $grey-lightest;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  height: 4rem;
  width: 100%;
  max-width: 1440px;
  margin: auto;
  z-index: 11;

  .logo-and-title {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    a {
      display: flex;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 55px;
        margin-right: 1.75rem;
      }

      h1 {
        font-size: 1.2rem;
        margin-bottom: 0;
      }
    }
  }

  .pagination-toggle {
    margin-left: 0.5rem;
    #toggle-pagination-sidebar-button {
      background: none;
    }
  }

  .search-rep-and-cart-container {
    display: flex;
    width: 50%;
    justify-content: flex-end;

    .rep-info-container {
      display: flex;
      align-items: center;
      margin-right: 0.5rem;
      span {
        margin-right: 0.5rem;
      }

      .dropdown-menu-container {
        position: relative;

        #toggle-rep-dropdown-button {
          background: none;
        }
        .rep-info-dropdown {
          position: absolute;
          z-index: 10;
          right: 0;
          box-shadow: 0px 9px 18px 0px #282a3014;
          border-radius: 0.5rem;
          background: white;
          min-width: 15rem;
          margin-top: 1.2rem;
          .info-options {
            background: white;
            padding: 1rem;
            padding-right: 1.5rem;
            width: 100%;

            .rep-info-dropdown-item {
              display: flex;
              align-items: center;
              margin-bottom: 0.5rem;

              &:nth-child(even) {
                margin-bottom: 0;
              }

              img {
                width: 1.5rem;
                margin-right: 1rem;
              }
              a {
                margin: 0;
                color: #000;
                &:hover{
                  text-decoration: underline !important;
                }
              }
            }

            .contact-rep {
              p {
                margin-bottom: 1rem;
                text-align: center;
              }
              button.btn {
                background: $dark;
                color: white;
                width: 90%;
                padding: 0.75rem;
              }
            }
          }

          .dealer-mode-option {
            display: flex;
            align-items: center;
            background: $grey-lightest;
            padding: 1rem;
            padding-right: 2rem;
            button {
              background: none;
              color: $grey-dark;
            }
            img {
              margin-right: 0.5rem;
            }
          }
        }
      }
    }

    .cart {
      position: relative;
      transition: all 0.2s;
      &:hover {
        transform: scale(1.1);
      }
      .locker-quantity {
        background: #d5000b;
        border-radius: 50%;
        color: white;
        position: absolute;
        top: -0.5rem;
        right: -0.5rem;
        height: 1.5rem;
        width: 1.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    }
  }

  @media screen and (max-width: 576px) {
    flex-flow: column;

    & > * {
      margin-bottom: 1rem;
      width: 100%;
    }

    .logo-and-title {
      img {
        margin: auto;
      }
    }
  }

  @media screen and (max-width: 786px) {
    display: none;
  }
}
</style>